<!-- Update Banner - Shows when app version is deprecated (dismissable) -->
<div class="update-banner" *ngIf="showBanner()">
  <div class="update-banner-content">
    <div class="update-banner-text">
      <span class="update-title">{{ ss.t('update_newVersionAvailable') }}</span>
    </div>
    <div class="update-banner-actions">
      <button class="update-btn-refresh" (click)="onRefresh()">
        <span>{{ ss.t('update_refreshNow') }}</span>
      </button>
      <button class="update-btn-later" (click)="onDismiss()" [attr.aria-label]="ss.t('update_later')">
        <app-svg name="nativeAppDownloadBannerClose" [color]="ss.theme().color16" width="18" height="18"></app-svg>
      </button>
    </div>
  </div>
</div>
